<template>
  <!-- 主容器 -->
  <div class="jump-modal-page">
    <!-- 内容区域 -->
    <div class="page-content">
      <!-- 错误状态显示 -->
      <div class="error-section">
        <div class="error-icon">⚠️</div>
        <div class="error-text">{{ errorMessage }}</div>
        <div class="error-actions">
          <el-button type="danger" @click="closePage">
            <span class="btn-icon">✕</span>关闭页面
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Button } from 'element-ui';

export default {
  name: 'JumpModalError',
  components: {
    'el-button': Button
  },
  data() {
    return {
      errorMessage: this.$route.query.message || '操作失败，请重试',
      // 开发环境标识
      isDevelopment: process.env.NODE_ENV === 'development'
    };
  },
  methods: {
    // 关闭页面
    closePage() {
      // 尝试关闭浏览器窗口（适用于通过 window.open 打开的页面）
      try {
        // 检查是否是通过 window.open 打开的窗口
        if (window.opener) {
          console.log('检测到是通过 window.open 打开的窗口，自动关闭');
          window.close();
        } else {
          // 如果无法关闭窗口，则返回登录页
          this.$router.push({
            name: 'Login',
            query: {
              error: 'sso_error'
            }
          });
        }
      } catch (error) {
        console.warn('关闭窗口失败:', error);
        // 即使关闭窗口失败，也要返回登录页
        this.$router.push({
          name: 'Login',
          query: {
            error: 'sso_error'
          }
        });
      }
    }
  }
};
</script>

<style scoped>
/* 主页面容器 */
.jump-modal-page {
  width: 100%;
  min-height: 100vh;
  background-color: #f5f7fa;
  display: flex;
  flex-direction: column;
}

/* 页面内容区域 */
.page-content {
  flex: 1;
  padding: 24px;
  max-width: 800px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
}

/* 错误状态 */
.error-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid #e8e8e8;
}

.error-icon {
  font-size: 64px;
  margin-bottom: 20px;
}

.error-text {
  font-size: 16px;
  color: #f56c6c;
  font-weight: 500;
  line-height: 1.6;
  margin-bottom: 24px;
  word-break: break-word;
  max-width: 400px;
}

.error-actions {
  display: flex;
  justify-content: center;
}

.btn-icon {
  margin-right: 4px;
  font-size: 14px;
}
</style>
